import { defineStyleConfig } from "@chakra-ui/react";

export const Table = defineStyleConfig({
  variants: {
    simple: {
      td: {
        border: "none",
        p: 8,
        fontSize: "xl",
        _dark: {
          color: "white",
        },
      },
      th: {
        letterSpacing: 0,
        border: "none",
        fontWeight: "bold",
        p: 8,
        fontSize: "xl",
        textTransform: "none",
        _dark: {
          color: "white",
        },
      },
    },
    small: {
      td: {
        border: "none",
        px: 0,
        fontSize: "lg",
        color: "warmgray.900",
        _dark: {
          color: "white",
        },
      },
      th: {
        letterSpacing: 0,
        border: "none",
        fontWeight: "bold",
        px: 0,
        fontSize: "lg",
        textTransform: "none",
        color: "warmgray.500",
        _dark: {
          color: "white",
        },
      },
    },
  },
});
